export default __webpack_public_path__ + "uhc-logo.88041cb.png";